import { Reducer } from 'redux';
import { ESCycle } from '~src/interfaces/cycle.interface';

import { ThunkFailAction, ThunkSuccessAction } from '~src/services/apiMiddleware';
import { SurveyStatsData, SurveySummary } from '~src/modules/reports/surveyProfile/interfaces/surveySummary.interface';
import {
  GET_SURVEY_ANSWERS_SUCCESS,
  GET_SURVEY_NEWS_SUCCESS,
  GET_SURVEY_PARTICIPANTS_SUCCESS,
  GET_SURVEY_QUESTIONS_SUCCESS,
  GET_SURVEY_SUMMARY_SUCCESS,
  GET_SURVEY_TOPICS_SUCCESS,
  SURVEY_PROFILE_ANY_FAILED,
  SURVEY_PROFILE_ANY_REQUEST,
} from '~src/modules/reports/surveyProfile/actions/surveyProfile.actions';
import {
  resultListToObject,
  ProfileState,
  defaultInitState,
} from '~src/modules/reports/shared/distributers/actionDistributor';
import {
  ParticipantsObj,
  ParticipantsResponse,
  ReportsParticipant,
} from '~src/modules/reports/interfaces/participants.interface';
import { ReportSubjectTypes } from '~src/modules/reports/interfaces/header.interface';

export interface SurveyProfileState extends ProfileState {
  loading: boolean;
  survey: SurveySummary | null;
  surveyStats: SurveyStatsData | null;
  participants: ParticipantsObj | null;
  cycle: ESCycle | null;
}

export function getInitialSurveyProfileState(): SurveyProfileState {
  return {
    ...defaultInitState,
    survey: null,
    cycle: null,
    surveyStats: null,
    participants: null,
  };
}

const surveyProfileReducer: Reducer<SurveyProfileState, ThunkSuccessAction | ThunkFailAction> = (
  state = getInitialSurveyProfileState(),
  action,
) => {
  switch (action.type) {
    case SURVEY_PROFILE_ANY_REQUEST:
      return { ...state, loading: true };

    case SURVEY_PROFILE_ANY_FAILED:
      return { ...state, lodaing: false };

    case GET_SURVEY_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        survey: action.response.data.survey,
        cycle: action.response.data.cycle,
        surveyStats: action.response.data.result,
      };

    case GET_SURVEY_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        news: resultListToObject(ReportSubjectTypes.News, action.response.data),
      };

    case GET_SURVEY_TOPICS_SUCCESS:
      return {
        ...state,
        loading: false,
        topics: resultListToObject(ReportSubjectTypes.Topic, action.response.data),
      };

    case GET_SURVEY_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: resultListToObject(ReportSubjectTypes.Question, action.response.data),
      };
    case GET_SURVEY_ANSWERS_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: resultListToObject(ReportSubjectTypes.Answer, action.response.data),
      };
    case GET_SURVEY_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        loading: false,
        participants: {
          ...(action.response.data.participant_list
            ? resultListToObject(ReportSubjectTypes.Participant, mapIdToObjects(action.response.data))
            : action.response.data.result),
          pagination: action.response.data.pagination,
        },
        cycle: action.response.data.cycle,
      };

    default:
      return state;
  }
};

const mapIdToObjects = (data: ParticipantsResponse) => {
  const dataCpy = { ...data };
  if (dataCpy.result.participant_list) {
    dataCpy.result.participant_list = dataCpy.result.participant_list.map((item: ReportsParticipant) => {
      item.id = item.user.id;
      return item;
    });
  }
  return dataCpy;
};

export default surveyProfileReducer;
